






import Vue from "vue";
import Presenca from "../components/Presenca.vue";
import OutrosClientes from "../components/OutrosClientes.vue";
export default {
  components: {
    Presenca,
    OutrosClientes
  }
};
